export const convertDateFormat = (stringDate: string) => {
  const newdate = stringDate?.split("/").reverse().join("-");
  return newdate;
};
